<template>
  <div class="container">
    <h2>{{ entity.name }}</h2>
    <form @submit.prevent="EditEntity">
        <div class="field title">
            <label for="name">Entity Name:</label>
            <input type="text" name="name" v-model="entity.name" @blur="$emit('entity-update', entity, 'name')">
        </div>
        <div class="field">
          <label for="type">Entity type:</label>
          <select class="browser-default" v-model="entity.type" @blur="$emit('entity-update', entity, 'type')">
            <option v-for="option in typeOptions" :value="option.value" :key="option.value">
              {{ option.text }}
            </option>
          </select>
        </div>
        <div class="input-field inline">
          <p>
          <label for="inScenario" @click="entity.inScenario=!entity.inScenario">
            <input type="checkbox" name="inScenario" v-model="entity.inScenario" @blur="$emit('entity-update', entity, 'inScenario')">
            <span>In Scenario: {{entity.inScenario}}</span>
          </label>
          </p>
        </div>
        <div v-if="entity.inScenario" class="input-field inline">
          <p>
            <label for="isPresent" @click="entity.isPresent=!entity.isPresent">
              <input type="checkbox" name="isPresent" v-model="entity.isPresent" @blur="$emit('entity-update', entity, 'isPresent')">
              <span>Is Present: {{entity.isPresent}}</span>
            </label>
          </p>
        </div>
        <br/>

        <div class="input-field inline">
          <input id="initiative" type="number" class="validate" min="-1" max="99" v-model="entity.initiative" @blur="$emit('entity-update', entity, 'initiative')">
          <span class="helper-text" data-error="wrong" data-success="good job">Initiative</span>
        </div>
        <div class="input-field inline" v-if="entity.initiative > 0">
          <input id="subInitiative" type="number" class="validate" min="-1" max="99" v-model="entity.subInitiative" @blur="$emit('entity-update', entity, 'subInitiative')">
          <span class="helper-text" data-error="wrong" data-success="good job">subInitiative</span>
        </div>
        
        <div class="field center-align">
            <button class="btn pink">Update Entity Details</button>
        </div>
    </form>
    </div>
</template>

<script>
import db from '@/firebase/init'
import slugify from 'slugify'

export default {
  name: 'EditEntity',
  props: ["entity"],
  
  data() {
    return {
      typeOptions: [
        {text: 'Player', value: 'player'},
        {text: 'Monster', value: 'monster'},
        {text: 'Boss', value: 'boss'},
        {text: 'Bug', value: 'bug'},
        {text: 'Accepted Feature', value: 'acceptedFeature'},
        {text: 'Idea', value: 'idea'},
        {text: 'Resource', value: 'resource'},
      ]
    }
  },
  methods: {
    EditEntity(){
      if (this.entity.name){
        db.collection('entities').doc(this.entity.id).update({
          name: this.entity.name,
          type: this.entity.type,
          imageID: this.imageID,
          isPresent: this.entity.isPresent,
          inScenario: this.entity.inScenario,
          initiative: this.entity.initiative,
          subInitiative: this.entity.subInitiative,
        }).then(() => {
          this.$router.push({ name: 'ScenarioStart' })
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  computed: {
    type(){
      return this.entity.type
    },
    imageID(){
      let sluggifiedName = slugify(this.entity.name, {
        remove: /[$*_+~.()'"!\-:@]/g,
        lower: true})
      return sluggifiedName + 'image.jpg'
    }
  }
}
</script>

<style scoped>
.h2{
  font-size: medium;
}
</style>


// WEBPACK FOOTER //
// src/components/EditEntity.vue